import Vue from 'vue'
import { mapGetters } from 'vuex'

export const ProductListMixin = {
	data() {
		return {
			lockedProducts: {},
		}
	},
  computed: {
    ...mapGetters("account", [
			"isLoggedIn",
			"accountGroupCodes",
		]),
  },
	methods: {
		enhanceProducts(products, specialIndex = -1) {
			return products
				.filter(product => {
					if (product.customerGroups && product.customerGroups.length) {
						if (this.isLoggedIn && this.accountGroupCodes.length) {
							return product.customerGroups.reduce((acc, group) => {
								return this.accountGroupCodes.includes(group) || acc;
							}, false);
						}
						return false;
					}
					return true;
				})
				.map((p, i) => {
					// prepare images
					const image = p.images.find(image => image.code == 'shopmanager_product');
					const imageSpecial = p.images.find(image => image.code == 'shopmanager_product_special');
					const imagesDetail = p.images.filter(image => image.code == 'shopmanager_product_detail');
					// prepare variants
					let variants = Object
						.values(p.variants)
						.map(variant => ({
							...variant,
							originalPrice: variant?.originalPrice?.current,
							price: variant?.price?.current
						}))
					return {
						special: i == specialIndex,
						...p,
						image: image ? image.path : p.images.length && p.images[0].path || '',
						imageSpecial: imageSpecial ? imageSpecial.path : imagesDetail.length ? imagesDetail[0].path : '',//image ? image.path : p.images.length && p.images[0].path || '',
						imagesDetail: imagesDetail.length ? imagesDetail.map(i => i.path) : [image ? image.path : p.images.length && p.images[0].path || ''],
						price: 0,
						variants,
						selectedVariant: variants[0].code,
					}
				})
				// .filter(product => product.stock != 0 && product.variants.find(v => v.stock != 0) != null) // filter out products with 0 stock or any with only 0 variants
				;
		},
		async onConfig(product) {
			htmlComponent.send('overlay:open', {type: 'overlay-childproducts', product, selectedCodes: product.defaultChildProducts});
		},
		async onAddToCart(item) {
			Vue.set(this.lockedProducts, item.productCode, true);
			try {
				const lastItem = await this.$store.dispatch('cart/addItems', {items: [item]})

				// HACK: we currently inform the sidebarcart about the add. This logic has to be changed in the future
				if (lastItem) {
					// currently we get only an item if its really an add, not just a quantity change
					// this.$refs.sidebarcart.onNotifyProductAdded(lastItem)

				}
			}
			catch(err) {
				let errorMessage;
				if (err.response && err.response.data.message) {
					if (Array.isArray(err.response.data.errors)) {
						err.response.data.errors = err.response.data.errors.reduce((e, error) => {
								Object.entries(error).forEach(([key, value]) => {
										if (e[key] && Array.isArray(e[key])) {
												e[key].push(...value);
										}
										else {
												e[key] = value;
										}
								})
								return e;
						}, {});
					}

					errorMessage = err.response.data.errors && Object.values(err.response.data.errors).length
						? Object.values(err.response.data.errors).flat().join()
						: err.response.data.message
				} else {
					errorMessage = this.$t('forms.errors.generic');
				}
				// console.log(errorMessage)
				this.$store.dispatch('dialog/showDialog', {
					title: this.$t('forms.errors.error'),
					message: errorMessage,
					confirm: 'OK',
				});
			}
			Vue.set(this.lockedProducts, item.productCode, false);
		},
		getProduct(code) {
			return this.productsEnhanced.find(product => product.code == code);
		},
	}
};

export default ProductListMixin;
